import { render, staticRenderFns } from "./form-copy.vue?vue&type=template&id=2b3e5cec&"
import script from "./form-copy.vue?vue&type=script&lang=js&"
export * from "./form-copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports